import { writable } from 'svelte/store';

const u = unwrap(localStorage.getItem("auth"))

export const user = writable(u);


user.subscribe(val => localStorage.setItem("auth", wrap(val)));

function wrap(j){
    if(j){
        return JSON.stringify(j)
    }else{
        return JSON.stringify({}) 
    }
}

function unwrap(s){
    if(s){
        return JSON.parse(s)
    }else{
        return {}
    }
}

function getUnixTime() { return new Date().getTime() / 1000 | 0 };
export function expired(){
    if(user.loggedIn){
        return (user.expires)<getUnixTime()
    }else{
        return true
    }
}